import RootState from "../../../store/state";
import logger from "../../../logger";
import * as TeamsAPI from "../../../services/api/api.teams";
import { teamsParser, teamsStatusesParser } from "../teams/parsers";
import { ThunkDispatch } from "redux-thunk";
import {
    getTeamsContactsLoading,
    setTeamsError,
    setTeamsStatuses,
    setTeamsStatusesLoading,
    TeamsAction,
} from "./actions";
import { TeamsActions } from "./types";
import { createNotification, NotificationAction } from 'store/notification/notification.actions';

export const getTeamsContacts = () => async (
    dispatch: ThunkDispatch<RootState, undefined, TeamsAction>,
    getState: () => RootState
) => {
    const { directory } = getState();

    try {
        if (
            !directory.teams.isTeamsContactsLoading &&
            directory.teams.contacts.length === 0
        ) {
            const { app, auth } = getState();

            dispatch(getTeamsContactsLoading(true));

            const teamsData = await TeamsAPI.getContacts(
                app.ID,
                app.instance!.ID,
                auth.token!
            );

            const parsedTeamsContacts = teamsParser(teamsData ?? []);

            dispatch({
                type: TeamsActions.GET_TEAMS_CONTACTS,
                payload: parsedTeamsContacts,
            });
        }
    } catch (error) {
        dispatch(getTeamsContactsLoading(false));

        const errorMsg = "Failed to fetch Teams contacts";

        logger.error("GET-TEAMS-CONTACTS", error as object);

        dispatch(setTeamsError(errorMsg));
    }
};

export const getTeamsContactsStatuses = () => async (
    dispatch: ThunkDispatch<RootState, undefined, TeamsAction | NotificationAction>,
    getState: () => RootState
) => {
    try {
        const { app, auth } = getState();

        dispatch(setTeamsStatusesLoading(true));

        const { teamsStatuses, updateTimeDelta } = await TeamsAPI.getContactsStatuses(
            app.ID,
            app.instance!.ID,
            auth.token!
        );

        const teamsStatusesUpdateTimeThresholdMs = 300000;

        // Show a notification warning if Teams statuses were updated 5 or more minutes ago
        if(updateTimeDelta >= teamsStatusesUpdateTimeThresholdMs) {
            dispatch(createNotification({
                header: 'Warning!',
                text: 'There are temporary problems with extracting of Teams data. Information about Teams users and their statuses may be obsolete.',
                type: 'warning',
            }))
        }

        const parsedTeamsStatuses = teamsStatusesParser(teamsStatuses.data);

        dispatch(setTeamsStatuses(parsedTeamsStatuses));
    } catch (error) {
        dispatch(setTeamsStatusesLoading(false));

        const errorMsg = "Failed to fetch Teams statuses";

        logger.error("GET-TEAMS-STATUSES", error as object);

        dispatch(setTeamsError(errorMsg));
    }
};
